import { apiProxyRequest } from "Api/apiProxyRequest";

import type {
  UpdateOrganizationSubscriptionAlertRequestProps,
  OrganizationSubscriptionAlert
} from "./types";

export const updateOrganizationSubscriptionAlertRequest = ({
  organizationId,
  subscriptionId,
  alertData
}: UpdateOrganizationSubscriptionAlertRequestProps) =>
  apiProxyRequest<OrganizationSubscriptionAlert>(
    `/organizations/${organizationId}/alerts/subscriptions/${subscriptionId}/usage`,
    "PATCH",
    { alerts: alertData }
  );
